export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idexpense: '',
        type_expense: '',
        descripcion: '',
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}